import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontWeights,
  standardColours,
  standardTransition,
} from '../styles';
import { Link } from './ui';

const StyledBlogMeta = styled.div`
  display: inline-flex;
  gap: 15px;
  padding: 10px 60px 10px 10px;
  align-items: center;
  background-color: ${standardColours.white};
  border-radius: 45px;
  margin-right: auto;
  margin-top: 30px;
`;

const StyledImageWrapper = styled(Link)``;

const StyledImage = styled(GatsbyImage)`
  border-radius: 50%;
  width: 60px;
  height: 60px;
`;

const StyledContent = styled.div``;

const StyledAuthor = styled.p`
  font-weight: ${fontWeights.semibold};

  a {
    transition: ${standardTransition('color')};

    &:hover {
      color: ${brandColours.tertiary};
    }
  }
`;

const StyledReadTime = styled.p`
  margin-top: 2px;
`;

const BlogMeta = ({ author, readTime }) => (
  <StyledBlogMeta>
    <StyledImageWrapper to={author}>
      <StyledImage
        image={author.image.gatsbyImageData}
        alt={author.image.alt}
      />
    </StyledImageWrapper>
    <StyledContent>
      <StyledAuthor>
        <Link to={author}>{author.title}</Link>
      </StyledAuthor>
      {readTime && <StyledReadTime>{readTime}</StyledReadTime>}
    </StyledContent>
  </StyledBlogMeta>
);

export default BlogMeta;
